import { DeeplinkService } from './../../services/deeplink.service';
import { Component, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentsService } from 'src/app/services/enviroment.service';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.scss'],
})
export class DeeplinkNewComponent {
  deepLinkRev: any;
  tokenHifpt: any;
  link: any;
  code: any;
  screen: any;
  dataGetLink: any;
  opened: any;

  constructor(
    readonly route: ActivatedRoute,
    readonly deeplinkService: DeeplinkService,
    readonly env: EnvironmentsService,
    readonly zone: NgZone,
  ) {

    this.route.queryParamMap.subscribe((res: any) => {
      this.code = this.route.snapshot.paramMap.get('code');
      this.screen = this.route.snapshot.paramMap.get('screen');
    });
    if (
      this.code &&
      this.code !== '' &&
      this.code !== null &&
      this.screen &&
      this.screen !== '' &&
      this.screen !== null
    ) {
    }
  }
}
